import React, {Component} from "react";
import StringUtil from "../../utils/StringUtil";
import RemotingService from "../../services/remoting-service/RemotingService";
import {Wizard} from "../../components";
import "./ConsentFormWizard.css";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import IntakeFormRadTextEnum from "./intakeformrad/enum/IntakeFormRadTextEnum";
import FormLanguages from "./enum/FormLanguages";
import IntakeFormRadPersonalInformation from "./intakeformrad/IntakeFormRadPersonalInformation";
import IntakeFormRadContactInformation from "./intakeformrad/IntakeFormRadContactInformation";
import IntakeFormRadReferralInformation from "./intakeformrad/IntakeFormRadReferralInformation";
import IntakeFormRadEmergencyContact from "./intakeformrad/IntakeFormRadEmergencyContact";
import IntakeFormRadHealthHistory from "./intakeformrad/IntakeFormRadHealthHistory";
import IntakeFormHeader from "./intakeform/IntakeFormHeader";
import NabidhConsentFormParts from "./nabidh/NabidhConsentFormParts";
import NabidhFormTextEnum from "./NabidhFormTextEnum";
import PatientUtil from "../../utils/PatientUtil";
import LookupService from "../../services/lookup/LookupService";
import {connect} from "react-redux";

class IntakeFormRadWizard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            consentDate: new Date(),
            // Personal Information
            firstName: "",
            middleName: "",
            lastName: "",
            dob: "",
            age: "",
            gender: "",
            idNo: "",
            nationality: null,
            maritalStatus: null,
            religion: null,
            language: null,

            // Contact Information
            phoneNumber: "",
            whatsappNumber: null,
            email: "",
            address: "",
            country: null,
            city: "",
            postalCode: "",
            haveAllergies: "",
            allergy: {},

            // Referral Information
            howHeardAboutClinic: "",
            referringPhysician: "",
            reasonForImaging: "",

            // Emergency Contact
            emergencyContactName: "",
            emergencyContactRelationshipType: "",
            emergencyContactPhone: "",

            // Health History - Medical Conditions
            markAllSelf: "",
            markAllFamily: "",
            asthmaSelf: "",
            asthmaFamily: "",
            tuberculosisSelf: "",
            tuberculosisFamily: "",
            pneumoniaSelf: "",
            pneumoniaFamily: "",
            covid19Self: "",
            covid19Family: "",
            cancerSelf: "",
            cancerFamily: "",
            osteoarthritisSelf: "",
            osteoarthritisFamily: "",
            osteoporosisSelf: "",
            osteoporosisFamily: "",
            rheumatoidArthritisSelf: "",
            rheumatoidArthritisFamily: "",
            thyroidDiseaseSelf: "",
            thyroidDiseaseFamily: "",
            abdominalDiseasesSelf: "",
            abdominalDiseasesFamily: "",
            breastDiseasesSelf: "",
            breastDiseasesFamily: "",
            diabetesSelf: "",
            diabetesFamily: "",
            kidneyDiseaseSelf: "",
            kidneyDiseaseFamily: "",
            heartDiseaseSelf: "",
            heartDiseaseFamily: "",
            otherConditionSelf: "",
            otherConditionFamily: "",

            // Individual family "who" fields for each condition
            asthmaFamilyWho: null,
            tuberculosisFamilyWho: null,
            pneumoniaFamilyWho: null,
            covid19FamilyWho: null,
            cancerFamilyWho: null,
            osteoarthritisFamilyWho: null,
            osteoporosisFamilyWho: null,
            rheumatoidArthritisFamilyWho: null,
            thyroidDiseaseFamilyWho: null,
            abdominalDiseasesFamilyWho: null,
            breastDiseasesFamilyWho: null,
            diabetesFamilyWho: null,
            kidneyDiseaseFamilyWho: null,
            heartDiseaseFamilyWho: null,
            otherConditionFamilyWho: null,

            // Health History - Medications and Treatments
            onMedicationSupplements: "",
            medicationDetails: "",
            everHadSurgery: "",
            surgeryDetails: "",
            currentlyReceivingHealthcare: "",
            healthcareDetails: "",
            hadPreviousImaging: "",
            previousImagingDetails: "",
            exerciseType: "",
            smokesCurrent: "",
            smokesHistory: "",
            consumesAlcohol: "",

            // Pregnancy Related
            currentlyPregnant: "",
            lastMenstrualPeriod: "",
            lastMenstrualPeriodDetails: "",

            // Radiology-Specific Questions
            hadContrastDyeLast6Days: "",
            calciumVitaminDToday: "",
            calciumVitaminDLast24Hours: "",
            nuclearMedicineScanBariumLast6Days: "",
            dexaScanLast12Months: "",
            fastingForUltrasoundXray: "",

            // Nabidh Consent Form
            nabidhConsentAction: null,
            nabidhWitnessName: "",
            nabidhWitnessSignature: null,
            nabidhRelationshipToPatient: "",
            patientSignature: "",

            // State management
            componentUpdated: false
        };
    }

    componentDidMount() {
        if (!this.props.form) {
            // Initialize with patient data
            let activeEmergencyContact = null;
            if (
                this.props.patient.emergencyContact &&
                this.props.patient.emergencyContact.length
            ) {
                activeEmergencyContact = this.props.patient.emergencyContact.find(
                    (contact) => contact.isActiveContact === true
                );
            }

            this.setState({
                firstName: this.props.patient.firstName || "",
                middleName: this.props.patient.middleName || "",
                lastName: this.props.patient.lastName || "",
                idNo: this.props.patient.eid || "",
                gender: this.props.patient.gender || "",
                dob: this.props.patient.birthday || "",
                nationality: this.props.patient.nationality || null,
                city: this.props.patient.countryOfResidence || "",
                email: this.props.patient.email || "",
                address: this.props.patient.address || "",
                postalCode: this.props.patient.postalCode || "",
                phoneNumber: this.props.patient.mobilePhone || "",
                emergencyContactName: activeEmergencyContact ? activeEmergencyContact.name : "",
                emergencyContactPhone: activeEmergencyContact ? activeEmergencyContact.mobilePhone : ""
            });
        }
        this.retrievePhoto();
    }

    retrievePhoto = () => {
        RemotingService.getRemoteCall(
            "api/patient/" + this.props.patient.id + "/document/" + "PHOTO",
            null,
            (dto) => {
                this.setState({photoValue: dto, newPhotoValue: dto});
            }
        );
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            JSON.stringify(this.props.form) !== JSON.stringify(prevState) &&
            this.props.form &&
            !this.state.componentUpdated
        ) {
            const formData = this.props.form;
            // When loading existing data, prioritize formData.allergy (from backend)
            // If no data from backend, preserve existing state object to maintain reference
            const allergyToUse = (formData.allergy && Object.keys(formData.allergy).length > 0)
                ? formData.allergy
                : (this.state.allergy || {});

            // Match lookup objects from Redux store for SelectInput compatibility
            const matchedFormData = this.matchLookupObjects({...formData});

            // Initialize NABIDH consent fields from backend data
            const nabidhConsent = formData.nabidhConsent;

            this.setState({
                ...matchedFormData,
                allergy: allergyToUse,
                componentUpdated: true,
                // NABIDH consent fields
                nabidhConsentAction: nabidhConsent?.consentType || null,
                nabidhWitnessName: nabidhConsent?.witnessName || "",
                nabidhWitnessSignature: nabidhConsent?.witnessSignature || null,
                nabidhRelationshipToPatient: nabidhConsent?.relationshipToPatient || "",
                patientSignature: nabidhConsent?.patientSignature || ""
            });
        }
    }

    matchLookupObjects = (formData) => {
        const {relationshipTypes, nationalities, countries, maritalStatuses, religions, languages} = this.props;

        // Match emergency contact relationship type
        const relationshipTypeObject = LookupService.matchLookupObject(
            formData.emergencyContactRelationshipType,
            relationshipTypes
        );
        if (relationshipTypeObject) {
            formData.emergencyContactRelationshipType = relationshipTypeObject;
        }

        // Match nationality lookup field
        const nationalityObject = LookupService.matchLookupObject(
            formData.nationality,
            nationalities
        );
        if (nationalityObject) {
            formData.nationality = nationalityObject;
        }

        // Match country lookup field
        const countryObject = LookupService.matchLookupObject(
            formData.country,
            countries
        );
        if (countryObject) {
            formData.country = countryObject;
        }

        // Match marital status lookup field
        const maritalStatusObject = LookupService.matchLookupObject(
            formData.maritalStatus,
            maritalStatuses
        );
        if (maritalStatusObject) {
            formData.maritalStatus = maritalStatusObject;
        }

        // Match religion lookup field
        const religionObject = LookupService.matchLookupObject(
            formData.religion,
            religions
        );
        if (religionObject) {
            formData.religion = religionObject;
        }

        // Match language lookup field
        const languageObject = LookupService.matchLookupObject(
            formData.language,
            languages
        );
        if (languageObject) {
            formData.language = languageObject;
        }

        // Match family history "who" fields
        const familyWhoFields = [
            'asthmaFamilyWho', 'tuberculosisFamilyWho', 'pneumoniaFamilyWho', 'covid19FamilyWho',
            'cancerFamilyWho', 'osteoarthritisFamilyWho', 'osteoporosisFamilyWho', 'rheumatoidArthritisFamilyWho',
            'thyroidDiseaseFamilyWho', 'abdominalDiseasesFamilyWho', 'breastDiseasesFamilyWho',
            'diabetesFamilyWho', 'kidneyDiseaseFamilyWho', 'heartDiseaseFamilyWho', 'otherConditionFamilyWho'
        ];

        familyWhoFields.forEach(field => {
            if (formData[field]) {
                const matchedObject = LookupService.matchLookupObject(formData[field], relationshipTypes);
                if (matchedObject) {
                    formData[field] = matchedObject;
                }
            }
        });

        return formData;
    }

    onSubmit = () => {
        if (this.props.form) {
            this.props.close();
        } else {
            if (!ValidationUtil.checkWithNotification(this.formFields)) {
                return;
            }

            const dto = {
                consentDate: this.state.consentDate,
                // Personal Information
                firstName: this.state.firstName,
                middleName: this.state.middleName,
                lastName: this.state.lastName,
                dob: this.state.dob,
                age: this.state.age,
                gender: this.state.gender,
                idNo: this.state.idNo,
                nationality: this.state.nationality,
                maritalStatus: this.state.maritalStatus,
                religion: this.state.religion,
                language: this.state.language,

                // Contact Information
                phoneNumber: this.state.phoneNumber,
                whatsappNumber: this.state.whatsappNumber,
                email: this.state.email,
                address: this.state.address,
                country: this.state.country,
                city: this.state.city,
                postalCode: this.state.postalCode,
                haveAllergies: this.state.haveAllergies,
                allergy: this.state.haveAllergies === "Yes" ? this.state.allergy : null,

                // Referral Information
                howHeardAboutClinic: this.state.howHeardAboutClinic,
                referringPhysician: this.state.referringPhysician,
                reasonForImaging: this.state.reasonForImaging,

                // Emergency Contact
                emergencyContactName: this.state.emergencyContactName,
                emergencyContactRelationshipType: this.state.emergencyContactRelationshipType,
                emergencyContactPhone: this.state.emergencyContactPhone,

                // Health History
                markAllSelf: this.state.markAllSelf,
                markAllFamily: this.state.markAllFamily,
                asthmaSelf: this.state.asthmaSelf,
                asthmaFamily: this.state.asthmaFamily,
                tuberculosisSelf: this.state.tuberculosisSelf,
                tuberculosisFamily: this.state.tuberculosisFamily,
                pneumoniaSelf: this.state.pneumoniaSelf,
                pneumoniaFamily: this.state.pneumoniaFamily,
                covid19Self: this.state.covid19Self,
                covid19Family: this.state.covid19Family,
                cancerSelf: this.state.cancerSelf,
                cancerFamily: this.state.cancerFamily,
                osteoarthritisSelf: this.state.osteoarthritisSelf,
                osteoarthritisFamily: this.state.osteoarthritisFamily,
                osteoporosisSelf: this.state.osteoporosisSelf,
                osteoporosisFamily: this.state.osteoporosisFamily,
                rheumatoidArthritisSelf: this.state.rheumatoidArthritisSelf,
                rheumatoidArthritisFamily: this.state.rheumatoidArthritisFamily,
                thyroidDiseaseSelf: this.state.thyroidDiseaseSelf,
                thyroidDiseaseFamily: this.state.thyroidDiseaseFamily,
                abdominalDiseasesSelf: this.state.abdominalDiseasesSelf,
                abdominalDiseasesFamily: this.state.abdominalDiseasesFamily,
                breastDiseasesSelf: this.state.breastDiseasesSelf,
                breastDiseasesFamily: this.state.breastDiseasesFamily,
                diabetesSelf: this.state.diabetesSelf,
                diabetesFamily: this.state.diabetesFamily,
                kidneyDiseaseSelf: this.state.kidneyDiseaseSelf,
                kidneyDiseaseFamily: this.state.kidneyDiseaseFamily,
                heartDiseaseSelf: this.state.heartDiseaseSelf,
                heartDiseaseFamily: this.state.heartDiseaseFamily,
                otherConditionSelf: this.state.otherConditionSelf,
                otherConditionFamily: this.state.otherConditionFamily,

                // Individual family "who" fields for each condition
                asthmaFamilyWho: this.state.asthmaFamilyWho,
                tuberculosisFamilyWho: this.state.tuberculosisFamilyWho,
                pneumoniaFamilyWho: this.state.pneumoniaFamilyWho,
                covid19FamilyWho: this.state.covid19FamilyWho,
                cancerFamilyWho: this.state.cancerFamilyWho,
                osteoarthritisFamilyWho: this.state.osteoarthritisFamilyWho,
                osteoporosisFamilyWho: this.state.osteoporosisFamilyWho,
                rheumatoidArthritisFamilyWho: this.state.rheumatoidArthritisFamilyWho,
                thyroidDiseaseFamilyWho: this.state.thyroidDiseaseFamilyWho,
                abdominalDiseasesFamilyWho: this.state.abdominalDiseasesFamilyWho,
                breastDiseasesFamilyWho: this.state.breastDiseasesFamilyWho,
                diabetesFamilyWho: this.state.diabetesFamilyWho,
                kidneyDiseaseFamilyWho: this.state.kidneyDiseaseFamilyWho,
                heartDiseaseFamilyWho: this.state.heartDiseaseFamilyWho,
                otherConditionFamilyWho: this.state.otherConditionFamilyWho,

                // Medications and Treatments
                onMedicationSupplements: this.state.onMedicationSupplements,
                medicationDetails: this.state.onMedicationSupplements !== "No" ? this.state.medicationDetails : "",
                everHadSurgery: this.state.everHadSurgery,
                surgeryDetails: this.state.everHadSurgery === "Yes" ? this.state.surgeryDetails : "",
                currentlyReceivingHealthcare: this.state.currentlyReceivingHealthcare,
                healthcareDetails: this.state.currentlyReceivingHealthcare === "Yes" ? this.state.healthcareDetails : "",
                hadPreviousImaging: this.state.hadPreviousImaging,
                previousImagingDetails: this.state.hadPreviousImaging === "Yes" ? this.state.previousImagingDetails : "",
                exerciseType: this.state.exerciseType,
                smokesCurrent: this.state.smokesCurrent,
                smokesHistory: this.state.smokesHistory,
                consumesAlcohol: this.state.consumesAlcohol,

                // Pregnancy
                currentlyPregnant: this.state.currentlyPregnant,
                lastMenstrualPeriod: this.state.currentlyPregnant === "Yes" || this.state.currentlyPregnant === "NA" ? "" : this.state.lastMenstrualPeriod,
                lastMenstrualPeriodDetails: this.state.lastMenstrualPeriod ? this.state.lastMenstrualPeriodDetails : "",

                // Radiology-Specific Questions
                hadContrastDyeLast6Days: this.state.hadContrastDyeLast6Days,
                calciumVitaminDToday: this.state.calciumVitaminDToday,
                calciumVitaminDLast24Hours: this.state.calciumVitaminDLast24Hours,
                nuclearMedicineScanBariumLast6Days: this.state.nuclearMedicineScanBariumLast6Days,
                dexaScanLast12Months: this.state.dexaScanLast12Months,
                fastingForUltrasoundXray: this.state.fastingForUltrasoundXray,

                // Nabidh Consent
                nabidhConsent: {
                    consentType: this.state.nabidhConsentAction || null,
                    patientSignature: this.state.patientSignature,
                    witnessName: this.state.nabidhWitnessName,
                    witnessSignature: this.state.nabidhWitnessSignature,
                    relationshipToPatient: this.state.nabidhRelationshipToPatient,
                    patientFullName: PatientUtil.getPatientName(this.props.patient.firstName, this.props.patient.middleName, this.props.patient.lastName),
                    patientMrn: StringUtil.mrn(this.props.patient.mrn),
                    patientDOB: this.props.patient.birthday
                }
            };

            RemotingService.postRemoteCall(
                "api/patient/" + this.props.patient.id + "/consent-for-intake-form-rad",
                dto,
                (result) => {
                    this.props.afterSave(result);
                    this.props.close();
                }
            );
        }
    };

    fieldChanged = (fieldName, value, validationCallback) => {
        this.setState({[fieldName]: value}, () => {
            if (validationCallback) {
                validationCallback(this);
            }
        });
    };

    fieldGroupChanged = (fieldGroupObject, value, validationCallback) => {
        this.setState(fieldGroupObject, () => {
            if (validationCallback) {
                validationCallback(this);
            }
        });
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature});
    };

    onSaveNabidhWitnessSignature = (signature) => {
        this.setState({nabidhWitnessSignature: signature});
    };

    render() {
        if (!this.props.show) return null;

        let {patient, form} = this.props;
        const readOnly = form !== null && form !== undefined;
        const mrnNo = StringUtil.mrn(patient.mrn);
        const selectedLanguage = this.props.selectedLanguage.name;
        const patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = [];

        const photoValue = this.state.photoValue;
        const photoSrc = photoValue
            ? `data:image/jpeg;base64,${photoValue.content}`
            : `${process.env.PUBLIC_URL}/assets/patient_profile.png`;

        const formBodyClass = this.props.selectedLanguage == FormLanguages.ARABIC ? "arabic-form" : "";
        const maxWidthClass = "form-body";
        const enumLabel = this.props.selectedLanguage == FormLanguages.ARABIC ? "nameInArabic" : "name";
        const nationalityLabel = this.props.selectedLanguage == FormLanguages.ARABIC ? "nameInArabic" : "nameInEnglish";
        
        const commonProps = {
            selectedLanguage,
            enumLabel,
            nationalityLabel,
            readOnly,
            onChange: this.fieldChanged,
            onFieldGroupChanged: this.fieldGroupChanged,
            formFields: this.formFields,
            pushFormFieldRef: this.pushFormFieldRef
        }

        return (
            <Wizard
                show={this.props.show}
                close={this.props.close}
                title={IntakeFormRadTextEnum.Intake_Form_Rad_Header[selectedLanguage]}
                onSubmit={this.onSubmit}
                isReadOnly={readOnly}
                previousBtnText={IntakeFormRadTextEnum.Wizard_Previous[selectedLanguage]}
                nextBtnText={IntakeFormRadTextEnum.Wizard_Next[selectedLanguage]}
                saveBtnText={IntakeFormRadTextEnum.Wizard_Save[selectedLanguage]}
            >
                {/* Page 1: Personal & Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${readOnly ? "TextInputDisabled" : ""}`}
                         style={{minHeight: "580px", width: "1000px"}}>
                        <IntakeFormHeader {...commonProps}
                                          photoSrc={photoSrc}
                                          mrnNo={mrnNo}
                                          consentDate={this.state.consentDate}
                                          title={IntakeFormRadTextEnum.Intake_Form_Rad_Title[selectedLanguage]}
                        />

                        <div className={formBodyClass}>
                            <IntakeFormRadPersonalInformation {...commonProps}
                                                              firstName={this.state.firstName}
                                                              middleName={this.state.middleName}
                                                              lastName={this.state.lastName}
                                                              dob={this.state.dob}
                                                              age={this.state.age}
                                                              gender={this.state.gender}
                                                              idNo={this.state.idNo}
                                                              nationality={this.state.nationality}
                                                              nationalities={this.props.nationalities}
                                                              maritalStatus={this.state.maritalStatus}
                                                              maritalStatuses={this.props.maritalStatuses}
                                                              religion={this.state.religion}
                                                              religions={this.props.religions}
                                                              language={this.state.language}
                                                              languages={this.props.languages}
                                                              haveAllergies={this.state.haveAllergies}
                                                              allergy={this.state.allergy}
                                                              allergyTypes={this.props.allergyTypes}
                                                              allergenTypes={this.props.allergenTypes}
                                                              allergySeverities={this.props.allergySeverities}
                                                              allergenReactionTypes={this.props.allergenReactionTypes}
                            />

                            <IntakeFormRadContactInformation {...commonProps}
                                                             phoneNumber={this.state.phoneNumber}
                                                             whatsappNumber={this.state.whatsappNumber}
                                                             email={this.state.email}
                                                             address={this.state.address}
                                                             country={this.state.country}
                                                             countries={this.props.countries}
                                                             city={this.state.city}
                                                             postalCode={this.state.postalCode}
                            />
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 2: Referral & Emergency Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadReferralInformation {...commonProps}
                                                          howHeardAboutClinic={this.state.howHeardAboutClinic}
                                                          referringPhysician={this.state.referringPhysician}
                                                          reasonForImaging={this.state.reasonForImaging}
                        />

                        <IntakeFormRadEmergencyContact {...commonProps}
                                                       emergencyContactName={this.state.emergencyContactName}
                                                       emergencyContactRelationshipType={this.state.emergencyContactRelationshipType}
                                                       emergencyContactPhone={this.state.emergencyContactPhone}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 3: Health History */}
                <Wizard.Page 
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadHealthHistory {...commonProps}
                                                    markAllSelf={this.state.markAllSelf}
                                                    markAllFamily={this.state.markAllFamily}
                                                    asthmaSelf={this.state.asthmaSelf}
                                                    asthmaFamily={this.state.asthmaFamily}
                                                    tuberculosisSelf={this.state.tuberculosisSelf}
                                                    tuberculosisFamily={this.state.tuberculosisFamily}
                                                    pneumoniaSelf={this.state.pneumoniaSelf}
                                                    pneumoniaFamily={this.state.pneumoniaFamily}
                                                    covid19Self={this.state.covid19Self}
                                                    covid19Family={this.state.covid19Family}
                                                    cancerSelf={this.state.cancerSelf}
                                                    cancerFamily={this.state.cancerFamily}
                                                    osteoarthritisSelf={this.state.osteoarthritisSelf}
                                                    osteoarthritisFamily={this.state.osteoarthritisFamily}
                                                    osteoporosisSelf={this.state.osteoporosisSelf}
                                                    osteoporosisFamily={this.state.osteoporosisFamily}
                                                    rheumatoidArthritisSelf={this.state.rheumatoidArthritisSelf}
                                                    rheumatoidArthritisFamily={this.state.rheumatoidArthritisFamily}
                                                    thyroidDiseaseSelf={this.state.thyroidDiseaseSelf}
                                                    thyroidDiseaseFamily={this.state.thyroidDiseaseFamily}
                                                    abdominalDiseasesSelf={this.state.abdominalDiseasesSelf}
                                                    abdominalDiseasesFamily={this.state.abdominalDiseasesFamily}
                                                    breastDiseasesSelf={this.state.breastDiseasesSelf}
                                                    breastDiseasesFamily={this.state.breastDiseasesFamily}
                                                    diabetesSelf={this.state.diabetesSelf}
                                                    diabetesFamily={this.state.diabetesFamily}
                                                    kidneyDiseaseSelf={this.state.kidneyDiseaseSelf}
                                                    kidneyDiseaseFamily={this.state.kidneyDiseaseFamily}
                                                    heartDiseaseSelf={this.state.heartDiseaseSelf}
                                                    heartDiseaseFamily={this.state.heartDiseaseFamily}
                                                    otherConditionSelf={this.state.otherConditionSelf}
                                                    otherConditionFamily={this.state.otherConditionFamily}

                                                    asthmaFamilyWho={this.state.asthmaFamilyWho}
                                                    tuberculosisFamilyWho={this.state.tuberculosisFamilyWho}
                                                    pneumoniaFamilyWho={this.state.pneumoniaFamilyWho}
                                                    covid19FamilyWho={this.state.covid19FamilyWho}
                                                    cancerFamilyWho={this.state.cancerFamilyWho}
                                                    osteoarthritisFamilyWho={this.state.osteoarthritisFamilyWho}
                                                    osteoporosisFamilyWho={this.state.osteoporosisFamilyWho}
                                                    rheumatoidArthritisFamilyWho={this.state.rheumatoidArthritisFamilyWho}
                                                    thyroidDiseaseFamilyWho={this.state.thyroidDiseaseFamilyWho}
                                                    abdominalDiseasesFamilyWho={this.state.abdominalDiseasesFamilyWho}
                                                    breastDiseasesFamilyWho={this.state.breastDiseasesFamilyWho}
                                                    diabetesFamilyWho={this.state.diabetesFamilyWho}
                                                    kidneyDiseaseFamilyWho={this.state.kidneyDiseaseFamilyWho}
                                                    heartDiseaseFamilyWho={this.state.heartDiseaseFamilyWho}
                                                    otherConditionFamilyWho={this.state.otherConditionFamilyWho}

                                                    onMedicationSupplements={this.state.onMedicationSupplements}
                                                    medicationDetails={this.state.medicationDetails}
                                                    everHadSurgery={this.state.everHadSurgery}
                                                    surgeryDetails={this.state.surgeryDetails}
                                                    currentlyReceivingHealthcare={this.state.currentlyReceivingHealthcare}
                                                    healthcareDetails={this.state.healthcareDetails}
                                                    hadPreviousImaging={this.state.hadPreviousImaging}
                                                    previousImagingDetails={this.state.previousImagingDetails}
                                                    exerciseType={this.state.exerciseType}
                                                    smokesCurrent={this.state.smokesCurrent}
                                                    smokesHistory={this.state.smokesHistory}
                                                    consumesAlcohol={this.state.consumesAlcohol}
                                                    currentlyPregnant={this.state.currentlyPregnant}
                                                    lastMenstrualPeriod={this.state.lastMenstrualPeriod}
                                                    lastMenstrualPeriodDetails={this.state.lastMenstrualPeriodDetails}
                                                    hadContrastDyeLast6Days={this.state.hadContrastDyeLast6Days}
                                                    calciumVitaminDToday={this.state.calciumVitaminDToday}
                                                    calciumVitaminDLast24Hours={this.state.calciumVitaminDLast24Hours}
                                                    nuclearMedicineScanBariumLast6Days={this.state.nuclearMedicineScanBariumLast6Days}
                                                    dexaScanLast12Months={this.state.dexaScanLast12Months}
                                                    fastingForUltrasoundXray={this.state.fastingForUltrasoundXray}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 4: NABIDH Consent Form - Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{NabidhFormTextEnum.Nabidh_Consent_Form_Title[selectedLanguage]}</b>
                        </h3>
                        <NabidhConsentFormParts.PatientInformation
                            selectedLanguage={selectedLanguage}
                            patientName={patientName}
                            mrnNo={mrnNo}
                            patientDOB={patient.birthday}
                        />
                        <NabidhConsentFormParts.NabidhInformation selectedLanguage={selectedLanguage}/>

                        <NabidhConsentFormParts.PatientSignatureSection
                            selectedLanguage={selectedLanguage}
                            readOnly={readOnly}
                            consentDate={readOnly ? new Date(form?.nabidhConsent?.consentDate || this.state.consentDate) : this.state.consentDate}
                            patientName={patientName}
                            patientSignature={readOnly ? form?.nabidhConsent?.patientSignature : this.state.patientSignature}
                            onSavePatientSignature={this.onSavePatientSignature}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 5: NABIDH Consent Form - Witness Section */}
                <Wizard.Page onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <NabidhConsentFormParts.WitnessSection
                            selectedLanguage={selectedLanguage}
                            readOnly={readOnly}
                            witnessName={readOnly ? form?.nabidhConsent?.witnessName : this.state.nabidhWitnessName}
                            witnessSignature={readOnly ? form?.nabidhConsent?.witnessSignature : this.state.nabidhWitnessSignature}
                            relationshipToPatient={readOnly ? form?.nabidhConsent?.relationshipToPatient : this.state.nabidhRelationshipToPatient}
                            onWitnessNameChange={(val) => this.setState({nabidhWitnessName: val})}
                            onRelationshipChange={(val) => this.setState({nabidhRelationshipToPatient: val})}
                            onSaveWitnessSignature={this.onSaveNabidhWitnessSignature}
                        />
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}

function mapStateToProps(state) {
    return {
        nationalities: state.base.lookupNationalities,
        countries: state.base.lookupCountries,
        relationshipTypes: state.base.relationshipTypes,
        maritalStatuses: state.base.lookupMaritalStatuses,
        religions: state.base.lookupReligions,
        languages: state.base.lookupLanguages,
        allergyTypes: state.base.allergyTypes,
        allergenTypes: state.base.allergenTypes,
        allergySeverities: state.base.allergySeverities,
        allergenReactionTypes: state.base.allergenReactionTypes
    };
}

export default connect(mapStateToProps)(IntakeFormRadWizard);